import { KeyValue } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { utcToZonedTime } from 'date-fns-tz';
import { ContractService } from 'src/app/services/contract.service';
import { MapGoogleService } from 'src/app/services/map-google.service';
import { MapService } from 'src/app/services/map.service';
import { TaskService } from 'src/app/services/task.service';
import { TeamService } from 'src/app/services/team.service';
import { VehicleService } from 'src/app/services/vehicles.service';
import {
  ActionEnum, ComplementInformationEnum,
  ComplementInformationSignEnum, PriorityEnum, SignalingTypeEnum,
  TaskTypeEnum,
  TodayTaskEnum, VerticalSignalizationTypeEnum,
  WarrantyStatusEnum
} from 'src/enumerators';
import { Member, Task, Team, TeamMember, Vehicle } from 'src/models';
@Component({
  selector: 'app-sidebar-team',
  templateUrl: './sidebar-team.component.html',
  styleUrls: ['./sidebar-team.component.css', '../sidebar-map.component.css', '../../../../map-page/map-page.component.css']
})
export class SidebarTeamComponent implements OnInit, OnChanges {

  currentTeam: Team;

  popoverCurrentTask: Task;
  complementInformationTypeEnum = ComplementInformationEnum;
  signTypeEnum = SignalingTypeEnum;
  signType = '';
  warrantyTypeEnum = WarrantyStatusEnum;
  warrantyType = '';
  retroreflection = ActionEnum.Retroreflection;

  lastSelected = '';
  membersList: Array<Member> = [];
  teamTasks: Map<string, Array<Task>> = new Map();
  taskProgressList = [];
  taskActivities: any // quantitativo das atividades
  taskActivitiesProgress: boolean[] = [] // Progresso em booleano das atividades
  totalTasksToday = 0;
  today: Date = new Date();
  @Input() sidebarIdSelected = '';
  @Input() currentTeamVehicle;

  @Output() changeIdEmitter = new EventEmitter<string>(); // Emite os valores para o componente pai;

  constructor(
    private _teamService: TeamService,
    private _taskService: TaskService,
    private _vehicleService: VehicleService,
    private _router: Router,
    private _contractService: ContractService,
    private _mapGoogleService: MapGoogleService,
    private _mapService: MapService,
  ) { }

  changeIdSelected(id) {
    this.sidebarIdSelected = id;
    this.changeIdEmitter.emit(id);

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.sidebarIdSelected?.currentValue != changes?.sidebarIdSelected?.previousValue && changes?.sidebarIdSelected?.previousValue) {
      this.getTeam();
      this.getTeamTasks();
    }
  }

  ngOnInit(): void {
    this.getTeam();
    this.getTeamTasks();
    this.getTaskProgress();
  }

  getMembers() {
    this._contractService.listAllWorkspaceUsers().subscribe((next: any) => {
      next.members.forEach(member => {
        this.membersList.push(member);
      });
      this.currentTeam.leaderMember = this.membersList.find(member => member.id == this.currentTeam.leaderMemberId);
    })
  }

  getMembersCheckIn(team: Team) {
    this._teamService.getActiveCheckInTeamMembers(team).subscribe(
      teamMembers => {
        this.currentTeam.members = teamMembers as TeamMember[];
      }
    )
  }

  getTaskProgress() {
    this._taskService.getTaskProgress().subscribe((progressList: any) => {
      this.taskProgressList = progressList;
    })
  }

  closeSideBar() {
    this._mapGoogleService.toggleSideBar(false);
    this._mapService.openSideBar(false);
  }

  setTaskMouseEnter(task) {
    this.popoverCurrentTask = task;
  }

  getTeam() {
    if (this.sidebarIdSelected != '-') {
      this._teamService.getTeam(this.sidebarIdSelected).subscribe((res: Team) => {
        this.currentTeam = res;
        this.currentTeam.members = [];
        this.getMembers();
        this.getMembersCheckIn(this.currentTeam);
      })
    }
  }

  // Seta o icone da tarefa
  setTaskIcon(taskType): Object {
    return {
      'fa-square-plus': taskType == TaskTypeEnum.Implantation,
      'fa-square-x': taskType == TaskTypeEnum.Removal,
      'fa-brush': taskType == TaskTypeEnum.Maintenance,
      'fa-arrow-down-to-bracket': taskType == TaskTypeEnum.Cataloging,
      'fa-arrows-cross': taskType == TaskTypeEnum.Replacement,
    };
  }

  getTeamTasks(endsAtPlus = false) {
    if (this.sidebarIdSelected != '-') {
      this._teamService.getTeamTasks(this.sidebarIdSelected, [TodayTaskEnum.FinishedToday]).subscribe((resFinished: Array<Task>) => {
        const tasksFinished = resFinished;
        tasksFinished.forEach(task => {
          const executionDate = utcToZonedTime(task.executionDate, 'UTC');
          task.executionDate = executionDate;
          task['isAccOpen'] = false;
        });
        this.teamTasks.set('Tarefas Concluídas do Dia', resFinished);
        this.totalTasksToday += resFinished.length;

        this._teamService.getTeamTasks(this.sidebarIdSelected, [TodayTaskEnum.OfToday]).subscribe((resToday: Array<Task>) => {
          const tasksToday = resToday.filter(task => {
            const executionDate = utcToZonedTime(task.executionDate, 'UTC');
            return (executionDate.toDateString() == this.today.toDateString())
          });

          tasksToday.forEach(task => {
            const executionDate = utcToZonedTime(task.executionDate, 'UTC');
            task.executionDate = executionDate;
            task['isAccOpen'] = false;

          });
          this.teamTasks.set('Tarefas do Dia', tasksToday);
          this.totalTasksToday += tasksToday.length;

          this._teamService.getTeamTasks(this.sidebarIdSelected, [TodayTaskEnum.LateToFinish]).subscribe((resLateFinish: Array<Task>) => {
            const tasksLateFinish = resLateFinish;
            tasksLateFinish.forEach(task => {
              const executionDate = utcToZonedTime(task.executionDate, 'UTC');
              task.executionDate = executionDate;
              task['isAccOpen'] = false;

            });
            this.totalTasksToday += tasksLateFinish.length;

            this._teamService.getTeamTasks(this.sidebarIdSelected, [TodayTaskEnum.LateToStart]).subscribe((resLateStart: Array<Task>) => {
              const tasksLateStart = resLateStart.filter(task => {
                const executionDate = utcToZonedTime(task.executionDate, 'UTC');
                return (executionDate.toDateString() != this.today.toDateString())
              });;
              tasksLateStart.forEach(task => {
                const executionDate = utcToZonedTime(task.executionDate, 'UTC');
                task.executionDate = executionDate;
                task['isAccOpen'] = false;
              });
              this.teamTasks.set('Tarefas Atrasadas do Dia', [...tasksLateStart, ...tasksLateFinish]);
              this.getTaskProgress();
              this.totalTasksToday += tasksLateStart.length;
            })
          })
        })
      })
    }
  }

  // Verifica se na lista de objetos tem algum objeto com certo ID e retorna o name dele;
  isValueKeyId(value, list): string {
    let name = '';
    list.some((element) => {
      if (element.id == value) {
        name = element.name;
      }
    });
    return name;
  }

  // Retorna qual é o tipo da informação complementar sabendo qual é o tipo da placa WARNING/REGULATION
  complementType(sign): ComplementInformationSignEnum {
    if (sign.complementInformationType == ComplementInformationEnum.Additional) {
      if (sign.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.AdditionalWarning;
      } else {
        return ComplementInformationSignEnum.AdditionalRegulation;
      }
    } else {
      if (sign.verticalType == VerticalSignalizationTypeEnum.Warning) {
        return ComplementInformationSignEnum.IncorporatedWarning;
      } else {
        return ComplementInformationSignEnum.IncorporatedRegulation;
      }
    }
  }

  // Preserva ordem do ngFor | keyvalue
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  };

  openAccordionGroup(itemTask: Task, listTask) {
    itemTask['isAccOpen'] = !itemTask['isAccOpen'];
    if (!itemTask['progress']) {
      itemTask['loading'] = true;
      this._taskService.getTaskById(itemTask.id).subscribe((task: Task) => {
        this._vehicleService.getVehicle(task.vehicleIds?.[0]).subscribe((vehicle: Vehicle) => {
          listTask.forEach(element => {
            if (element.id == itemTask.id) {
              itemTask = task;
              element.loading = false;
              element['progress'] = this.taskProgressList.find((el) => el.taskId == task.id);
              element['taskActivitiesProgress'] = []
              for (let index = 0; index < element.progress?.activities; index++) {
                element['taskActivitiesProgress'].push(index < element.progress?.completedActivities);
              }
              element.vehicle = vehicle;
              element['activitySigns'] = this.getActivities(element);
            }
          });
        })
      })
    }
  }

  // Troca de página para detalhes
  goToTeamDetail(teamId): void {
    this._router.navigate([`/services/teams/checkout`], { queryParams: { id: teamId, detail: true } });
  }

  // Leva para tarefa que estava 'Aguardando Edição'
  goToTaskDetail(taskId: string) {
    this._router.navigate([`/services/task/resume/task-resume/${taskId}`]);
  }

  // Popula as atividades da tarefa
  getActivities(task: Task) {
    let activitySigns = [];
    task.trafficSignTaskActivities.forEach(task => {
      activitySigns.push({
        signName: task.verticalCode,
        progress: `${task.quantityRegistered} / ${task.quantity}`
      })
    })
    task.horizontalSignalingTaskActivities.forEach(task => {
      activitySigns.push({
        signName: task.horizontalCode,
        progress: `${task.quantityRegistered} / ${task.quantity}`
      })
    })
    task.deviceSignalingTaskActivities.forEach(task => {
      activitySigns.push({
        signName: task.deviceCode,
        progress: `-`
      })
    })
    task.maintenanceTrafficSignTaskActivities.forEach(task => {
      activitySigns.push({
        signName: task.sign.verticalCode,
        progress: `-`
      })
    })
    task.maintenanceHorizontalSignalingTaskActivities.forEach(task => {
      activitySigns.push({
        signName: task.sign.horizontalCode,
        progress: `-`
      })
    })
    task.maintenanceDeviceSignalingTaskActivities.forEach(task => {
      activitySigns.push({
        signName: task.sign.deviceCode,
        progress: `-`
      })
    })

    return activitySigns;
  }

  getInitials(teamMember: TeamMember) {
    return this._teamService.getTeamMemberInitials(teamMember);
  }

}
